/**
 * PricingCTAFinal - Section CTA finale de la page pricing
 */

import { ArrowRight, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export function PricingCTAFinal() {
  return (
    <section className="relative py-24">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[500px] bg-gradient-radial from-[#F59E0B]/10 via-transparent to-transparent" />
      </div>

      <div className="container relative z-10 mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          {/* Title */}
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            Prêt à reprendre le contrôle ?
          </h2>

          {/* Subtitle */}
          <p className="text-lg text-white/50 mb-10 max-w-xl mx-auto">
            Essayez B8ild gratuitement pendant 14 jours.
            <br />
            Aucun engagement, annulation en un clic.
          </p>

          {/* CTA Button */}
          <Button
            size="lg"
            className="h-14 px-8 bg-[#F59E0B] hover:bg-[#FBBF24] text-[#0A0A0F] font-semibold text-lg rounded-xl shadow-[0_0_0_1px_rgba(245,158,11,0.3),0_4px_30px_rgba(245,158,11,0.4)] hover:shadow-[0_0_0_1px_rgba(245,158,11,0.5),0_8px_40px_rgba(245,158,11,0.5)] transition-all duration-300 group"
            asChild
          >
            <Link to="/auth?mode=signup">
              Commencer l'essai gratuit
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </Link>
          </Button>

          {/* Trust badges */}
          <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
            {[
              "14 jours gratuits",
              "Toutes les fonctionnalités Pro",
              "Support inclus",
            ].map((text, i) => (
              <div key={i} className="flex items-center gap-2">
                <div className="h-5 w-5 rounded-[4px] bg-[#131318] border border-white/[0.06] flex items-center justify-center">
                  <Check className="h-3 w-3 text-white/50" strokeWidth={2.5} />
                </div>
                <span className="text-sm text-white/50">{text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default PricingCTAFinal;
